/*
 * Writes a freshly created record into a cached list, so the page the
 * app navigates to right after a POST already holds it: the master
 * table selects the new row at once, in step with the details below,
 * instead of falling back to the first row until the refetch arrives.
 *
 * The seed is a stopgap, not the truth: every create hook still
 * invalidates its lists, and the server's own answer replaces the
 * seeded entry as soon as it comes in. Only a list that is already
 * cached is touched — where none is, the page fetches fresh anyway.
 * A record already present, or one without a uuid, leaves the cache
 * as it stands.
 */
export function seedListCache(queryClient, queryKey, created) {
  if (!created?.uuid) return;
  queryClient.setQueryData(queryKey, (rows) =>
    Array.isArray(rows) && !rows.some((row) => row.uuid === created.uuid)
      ? [...rows, created]
      : rows
  );
}
